import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BulbOutlinedSvg from "@ant-design/icons-svg/es/asn/BulbOutlined";
import AntdIcon from '../components/AntdIcon';
var BulbOutlined = function BulbOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: BulbOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(BulbOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'BulbOutlined';
}
export default RefIcon;